module.exports = __webpack_public_path__ + "img/3.3.3.f8a6e02a.png";